
export default  function GeozoneDetailsLogController($scope, $filter, $stateParams, GeozoneService, gettextCatalog) {

    'ngInject';

    $scope.loading = true;
    $scope.geozoneName = "";

    $scope.$on("name-provided", function (event, args) {
        if (!args.name) {
            $scope.geozoneName = $stateParams.geozoneId;
        } else {
            $scope.geozoneName = args.name;
        }

    });

    //Local Variables
    $scope.geozoneLogs = [];
    $scope.geozoneLogsByPage = [];
    $scope.filteredGeozoneLogs = [];


    //Pagination
    $scope.current = {
        geozoneLogPage: 1
    };
    $scope.itemsPerPage = 15;
    $scope.maxSize = 1;

    //Sorting
    $scope.predicate = 'timestamp';
    $scope.reverse = true;
    var orderBy = $filter('orderBy');

    //Sort filteredGeozoneLogs
    $scope.orderGeozoneLogs = function (predicate) {
        $scope.predicate = predicate;
        $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;

        angular.forEach($scope.filteredGeozoneLogs, function (entry) {
            entry[predicate] = entry[predicate];
        });
        $scope.filteredGeozoneLogs = orderBy($scope.filteredGeozoneLogs, predicate, $scope.reverse);
        $scope.displayGeozonesByPage();
    };

    //displayGeozonesByPage() is used to set the legnth of paging needed for filteredGeozoneLogs.
    $scope.displayGeozonesByPage = function () {
        $scope.totalItems = $scope.filteredGeozoneLogs.length;
        var begin = (($scope.current.geozoneLogPage - 1) * $scope.itemsPerPage);
        var end = begin + $scope.itemsPerPage;
        $scope.geozoneLogsByPage = $scope.filteredGeozoneLogs.slice(begin, end);
        $scope.loading = false;
    };

    //Calls displayGeozonesByPage(), everytime the the user changes the page.
    $scope.pageChanged = function () {
        $scope.displayGeozonesByPage();
    };

    var refresh = function () {
        GeozoneService.log($stateParams.geozoneId).then(function (response) {
            $scope.geozoneLogs = response.data;
            $scope.filteredGeozoneLogs = $scope.geozoneLogs;
            $scope.orderGeozoneLogs('timestamp', false);
            $scope.displayGeozonesByPage();
            $scope.loading = false;
        }, function (error) {
            var errorMsg = gettextCatalog.getString("An error occurred while retrieving GeoZone log data");
            if (error.data || error.status) {
                if (error.data.message) {
                    errorMsg = error.data.message + " " + (error.status.toString());
                } else {
                    errorMsg += ": " + (error.status.toString());
                }
            } else {
                errorMsg += gettextCatalog.getString(". Please try again later.");
            }
            $scope.onLoadErrorFlag = true;
            $scope.onLoadErrorText = errorMsg;
            $scope.loading = false;
        });
    };

    refresh();

    $scope.getCsvFileName = function () {

        var fileName = "";
        fileName += $scope.geozoneName + "_Log_" + new Date().toDateString();
        return fileName + ".csv";
    };

    $scope.getCsvData = function () {

        var columnArray = []; //array of rows
        var headerArray = [];
        headerArray.push('Date/Time');
        headerArray.push('Asset');
        headerArray.push('Event');

        columnArray.push(headerArray);

        for (var i = 0; i < $scope.geozoneLogs.length; i++) {

            var rowArray = []; //represents list of values for one row
            rowArray.push($scope.geozoneLogs[i].timestamp);
            rowArray.push($scope.geozoneLogs[i].equipment.name);
            rowArray.push($scope.geozoneLogs[i].event);


            columnArray.push(rowArray);
        }

        return columnArray;
    };
}
